import { render, staticRenderFns } from "./TableSearch.vue?vue&type=template&id=72f5e24c&"
import script from "./TableSearch.vue?vue&type=script&lang=js&"
export * from "./TableSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports